export const CV_URL = "/assets/Said_Kalil_CV_2026.pdf";
export const HERO_IMG = "/assets/hero_bw.png";
export const SOBRE_IMG = "/assets/sobre_suit.png";
export const LOGO = "/assets/logo_yellow.webp";
export const REEL_URL = "/assets/sk_reel.mp4";

export const WA_MAIN = "https://wa.link/87f00x";
export const WA_US = "https://wa.link/fuadp9";

export const CONTACT = {
  email: "said7kalil@gmail.com",
  phone: "+593 99 882 7568",
  phoneWa: WA_MAIN,
  phone2: "+1 (347) 799 8527",
  phone2Wa: WA_US,
  linkedin: "https://linkedin.com/in/saidkalil",
  linkedinLabel: "linkedin.com/in/saidkalil",
};

export const content = {
  es: {
    flag: "es",
    langCode: "ES",
    nav: { home: "Home", services: "Servicios", about: "Sobre mí", work: "Experiencia", education: "Formación", contact: "Contacto", cv: "Descargar CV", reel: "Reel" },
    hero: {
      role: "Ingeniero Multimedia · Estratega de Marketing",
      pre: "Diseño,",
      highlight: "estrategia",
      post: "y narrativa digital",
      subtitle: "Más de 15 años transformando marcas a través del diseño, la multimedia y el marketing digital — desde Ecuador hasta Noruega, Dinamarca, Chile, Japón y Nueva York.",
      cta: "Escríbeme",
    },
    stats: [
      { value: "+15", label: "Años de experiencia" },
      { value: "+9", label: "Países de operación" },
      { value: "35%", label: "Crecimiento en ventas" },
    ],
    services: {
      tag: "Servicios",
      title: "¿Qué ofrezco?",
      items: [
        { icon: "monitor", title: "Diseño Gráfico y Web", desc: "Diseño gráfico, dirección multimedia, edición de video y fotografía con estándar editorial internacional." },
        { icon: "smartphone", title: "Diseño de Apps Nativas y Web", desc: "Creamos la interfaz visual y la experiencia de interacción para que una app sea atractiva, intuitiva y fácil de usar en teléfonos." },
        { icon: "megaphone", title: "Estrategia de Marketing", desc: "Estrategias de comercialización, contenido, relaciones públicas, redes sociales y comunicación con inversionistas." },
        { icon: "cpu", title: "Social Media, Tecnología & IA", desc: "Computación en la nube, DevOps, SEO, e integración de IA y ciencia de datos en la estrategia de marca." },
      ],
    },
    about: {
      tag: "Sobre mí",
      title: "Una trayectoria que cruza continentes.",
      body: [
        "Mi camino comenzó en 2012, tras graduarme como Ingeniero en Producción y Dirección Multimedia. Después de mis primeros trabajos en el medio local, lideré el departamento de diseño de una empresa noruega con sede en Puerto Montt, Chile.",
        "Durante más de 8 años dirigí campañas, diseño y relaciones con clientes en Noruega, Reino Unido, Dinamarca, Chile y Canadá, asumiendo el liderazgo del equipo gráfico global. Hoy me desempeño como Director de Marketing en Fireguard America, en Nueva York.",
      ],
      name: "Said Kalil C.",
      role: "Ingeniero en Producción y Dirección Multimedia",
      checks: ["+1200 Proyectos completados", "+1000 clientes satisfechos", "Múltiples reconocimientos en Diseño"],
    },
    work: {
      tag: "Experiencia",
      title: "Trayectoria profesional.",
      jobs: [
        { role: "Director de Marketing", company: "Fireguard America", period: "Abr 2026 — Presente", place: "Nueva York, EE.UU.", desc: "Lidero la marca, las comunicaciones estratégicas y el desarrollo de mercado, posicionando a Fireguard como líder en la prevención proactiva de incendios eléctricos. Creo alianzas con aseguradoras, administradores de propiedades, agencias gubernamentales y cuerpos de bomberos." },
        { role: "Diseñador Gráfico Senior", company: "Oceanspace Media", period: "2017 — Feb 2026", place: "Noruega · Chile · Ecuador · Dinamarca", desc: "A cargo de las revistas del grupo en Noruega, Reino Unido y Chile. En 2021 nombrado líder del equipo gráfico global; en 2024 lideré un nuevo equipo en Dinamarca para dos revistas de la industria acuícola y naviera." },
        { role: "Diseñador UX", company: "BanChile Inversiones Dev", period: "2016", place: "Chile", desc: "Responsable de la experiencia UX junto a un equipo que funcionó como enlace con el departamento de UI del banco." },
        { role: "Analista Grado 1 en Diseño", company: "Gobierno Provincial del Guayas", period: "2014 — 2016", place: "Guayaquil, Ecuador", desc: "Diseñador para la campaña de reelección del Prefecto y asesor digital de la Prefectura. Reconocido entre los diseñadores más destacados de la institución." },
        { role: "Redactor de Deportes", company: "Ecuavisa.com", period: "2013 — 2014", place: "Guayaquil, Ecuador", desc: "Periodista en la sección de Deportes y redes sociales del canal más grande de Ecuador, a cargo de cobertura de partidos y noticias deportivas." },
        { role: "Webmaster & Estratega SEO", company: "Corporación Noboa", period: "2012 — 2013", place: "Ecuador", desc: "Encargado de la estrategia SEO y la reputación digital del filántropo Álvaro Noboa Pontón en múltiples sitios web." },
        { role: "Diseñador Gráfico, Web y Multimedia", company: "Sodicor SA", period: "2011 — 2012", place: "Miami, EE.UU.", desc: "Sitio web del Ministerio de Industrias del Ecuador, Expoecuador Miami 2011 y proyectos de branding para negocios locales." },
      ],
    },
    education: {
      tag: "Formación",
      title: "Educación.",
      degrees: [
        { title: "Ingeniero en Producción y Dirección Multimedia", org: "Universidad Católica Santiago de Guayaquil", year: "2012" },
        { title: "Diplomado en Dirección de Proyectos", org: "Universitat de València, España", year: "2011" },
        { title: "Diplomado en SEO y HTML5", org: "Universidad Central, Chile", year: "2011" },
      ],
    },
    extras: {
      langTitle: "Idiomas",
      langs: [
        { name: "Español", level: "Nativo" },
        { name: "Inglés", level: "Avanzado · C1" },
      ],
      certsTitle: "Certificaciones",
      certs: [
        "Adobe Illustrator & Photoshop — ESPOL",
        "Adobe After Effects — ESPOL",
        "Google Cloud Platform — Platzi",
        "Cloud Computing & DevOps — Platzi",
        "IA & Ciencia de Datos — Platzi",
        "Office 365 / Adobe Creative Cloud",
      ],
    },
    contact: {
      tag: "Contacto",
      title: "Construyamos algo memorable.",
      subtitle: "Disponible para proyectos de marca, dirección creativa y estrategia digital.",
      form: { name: "Nombre", email: "Correo", message: "Mensaje", send: "Enviar mensaje", sending: "Enviando…", success: "¡Gracias! Recibí tu mensaje, te responderé pronto.", error: "No se pudo enviar. Escríbeme por WhatsApp.", required: "Por favor completa todos los campos.", noconfig: "El formulario aún no está configurado.", mailto: "Se abrió tu aplicación de correo con el mensaje listo para enviar." },
      directTitle: "O contáctame directo",
      whatsapp: "Escríbeme por WhatsApp",
      emailLabel: "Correo",
      phoneLabel: "WhatsApp Ecuador",
      phone2Label: "WhatsApp EE.UU.",
    },
    footer: "Diseñado con intención · Guayaquil / Nueva York",
    reelTitle: "Showreel",
  },
  en: {
    flag: "us",
    langCode: "EN",
    nav: { home: "Home", services: "Services", about: "About", work: "Experience", education: "Education", contact: "Contact", cv: "Download CV", reel: "Reel" },
    hero: {
      role: "Multimedia Engineer · Marketing Strategist",
      pre: "Design,",
      highlight: "strategy",
      post: "& digital narrative",
      subtitle: "Over 15 years transforming brands through design, multimedia and digital marketing — from Ecuador to Norway, Denmark, Chile, Japan and New York.",
      cta: "Message me",
    },
    stats: [
      { value: "+15", label: "Years of experience" },
      { value: "+9", label: "Countries of operation" },
      { value: "35%", label: "Sales growth led" },
    ],
    services: {
      tag: "Services",
      title: "What do I offer?",
      items: [
        { icon: "monitor", title: "Graphic & Web Design", desc: "Graphic design, multimedia direction, video and photo editing to an international editorial standard." },
        { icon: "smartphone", title: "Native & Web App Design", desc: "We craft the visual interface and interaction experience so an app is attractive, intuitive and easy to use on phones." },
        { icon: "megaphone", title: "Marketing Strategy", desc: "Go-to-market strategy, content, public relations, social media and investor communications." },
        { icon: "cpu", title: "Social Media, Technology & AI", desc: "Cloud computing, DevOps, SEO, and the integration of AI and data science into brand strategy." },
      ],
    },
    about: {
      tag: "About me",
      title: "A journey across continents.",
      body: [
        "My path began in 2012, after graduating as a Multimedia Production & Direction Engineer. Following my first roles in the local scene, I led the design department of a Norwegian company based in Puerto Montt, Chile.",
        "For over 8 years I directed campaigns, design and client relations across Norway, the UK, Denmark, Chile and Canada, taking on leadership of the global graphic team. Today I serve as Marketing Director at Fireguard America in New York.",
      ],
      name: "Said Kalil C.",
      role: "Multimedia Production & Direction Engineer",
      checks: ["+1200 Projects completed", "+1000 satisfied clients", "Multiple Design awards"],
    },
    work: {
      tag: "Experience",
      title: "Professional career.",
      jobs: [
        { role: "Marketing Director", company: "Fireguard America", period: "Apr 2026 — Present", place: "New York, USA", desc: "I lead brand, strategic communications and market development, positioning Fireguard as a leader in proactive electrical fire prevention. I build alliances with insurers, property managers, government agencies and fire departments." },
        { role: "Senior Graphic Designer", company: "Oceanspace Media", period: "2017 — Feb 2026", place: "Norway · Chile · Ecuador · Denmark", desc: "In charge of the group's magazines in Norway, the UK and Chile. In 2021 appointed global graphic team lead; in 2024 I led a new team in Denmark for two magazines in the aquaculture and shipping industries." },
        { role: "UX Designer", company: "BanChile Inversiones Dev", period: "2016", place: "Chile", desc: "Responsible for UX experience alongside a team that served as liaison with the bank's UI department." },
        { role: "Design Analyst Grade 1", company: "Guayas Provincial Government", period: "2014 — 2016", place: "Guayaquil, Ecuador", desc: "Designer for the Prefect's re-election campaign and digital advisor to the Prefecture. Recognized among the institution's most outstanding designers." },
        { role: "Sports Writer", company: "Ecuavisa.com", period: "2013 — 2014", place: "Guayaquil, Ecuador", desc: "Journalist in the Sports and social media section of Ecuador's largest channel, covering matches and sports news." },
        { role: "Webmaster & SEO Strategist", company: "Corporación Noboa", period: "2012 — 2013", place: "Ecuador", desc: "Responsible for SEO strategy and the digital reputation of philanthropist Álvaro Noboa Pontón across multiple websites." },
        { role: "Graphic, Web & Multimedia Designer", company: "Sodicor SA", period: "2011 — 2012", place: "Miami, USA", desc: "Website for Ecuador's Ministry of Industries, Expoecuador Miami 2011, and branding projects for local businesses." },
      ],
    },
    education: {
      tag: "Education",
      title: "Education.",
      degrees: [
        { title: "Multimedia Production & Direction Engineer", org: "Universidad Católica Santiago de Guayaquil", year: "2012" },
        { title: "Diploma in Project Management", org: "Universitat de València, Spain", year: "2011" },
        { title: "Diploma in SEO & HTML5", org: "Universidad Central, Chile", year: "2011" },
      ],
    },
    extras: {
      langTitle: "Languages",
      langs: [
        { name: "Spanish", level: "Native" },
        { name: "English", level: "Advanced · C1" },
      ],
      certsTitle: "Certifications",
      certs: [
        "Adobe Illustrator & Photoshop — ESPOL",
        "Adobe After Effects — ESPOL",
        "Google Cloud Platform — Platzi",
        "Cloud Computing & DevOps — Platzi",
        "AI & Data Science — Platzi",
        "Office 365 / Adobe Creative Cloud",
      ],
    },
    contact: {
      tag: "Contact",
      title: "Let's build something memorable.",
      subtitle: "Available for brand projects, creative direction and digital strategy.",
      form: { name: "Name", email: "Email", message: "Message", send: "Send message", sending: "Sending…", success: "Thanks! I received your message and will reply soon.", error: "Could not send. Message me on WhatsApp.", required: "Please complete all fields.", noconfig: "The form is not configured yet.", mailto: "Your email app opened with the message ready to send." },
      directTitle: "Or reach me directly",
      whatsapp: "Message me on WhatsApp",
      emailLabel: "Email",
      phoneLabel: "WhatsApp Ecuador",
      phone2Label: "WhatsApp USA",
    },
    footer: "Designed with intent · Guayaquil / New York",
    reelTitle: "Showreel",
  },
};
